// extracted by css-extract-rspack-plugin
export default {"cls1":"dossier-cls1_0qf","cls2":"dossier-cls2_l7T dossier-cls1_0qf"};